<template lang="pug">
  .d-inline-block
    v-card.round-lg.mt-4.mb-8.pa-4.card-style
      .text-xl.font-semibold +{{ pointAdded }} {{ 'pt' | pluralize({ count:pointAdded }) }}
      .text-xl.font-semibold(style="color: #814711") {{ 'point' | pluralize({ count:pointAdded }) }} added
    .text-lg.font-semibold.mb-4 {{ member.name }} has received {{ pointAdded }} {{ 'point' | pluralize({ count:pointAdded }) }}!
</template>

<script>

export default {
  props: {
    member: {
      type: Object,
      required: true
    },
    pointAdded: {
      type: Number,
      required: true
    },
  },
}
</script>

<style scoped>
.card-style {
  background: linear-gradient(180deg, #FFD88C 0%, #DAA02F 100%) !important;
  box-shadow: 0px 4px 14.8px 0px #FFBA5280 !important;
}
</style>